import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { AiTaskApi } from 'api-typings/ai/ai';
import { transformAiSmartCanvasMakeReal } from './ai-smart-canvas-make-real.transformers';
import type { AiSmartCanvasMakeRealCollection } from './ai-smart-canvas-make-real.types';

export function aiSmartCanvasMakeRealReducer(
  state: CollectionStateSlice<AiSmartCanvasMakeRealCollection> = {},
  action: CollectionActions<AiSmartCanvasMakeRealCollection>,
): CollectionStateSlice<AiSmartCanvasMakeRealCollection> {
  switch (action.type) {
    case 'WS_MESSAGE':
      if (
        action.payload.parent_type === 'notifications' &&
        action.payload.type === 'aiFramework' &&
        action.payload.data.task === AiTaskApi.SMART_CANVAS_MAKE_REAL
      ) {
        const ref = {
          path: {
            collection: 'aiMakeReal',
            authUid: action.payload.toUserId,
          },
        };
        return mergeWebsocketDocuments<AiSmartCanvasMakeRealCollection>(
          state,
          transformIntoDocuments(
            [action.payload.data],
            transformAiSmartCanvasMakeReal,
          ),
          ref,
        );
      }

      return state;
    default:
      return state;
  }
}
